import React from 'react';
import {
  Box,
  Container,
  Tabs,
  Tab,
  Paper,
  Card,
  CardContent,
} from '@mui/material';
import { BarChart as BarChartIcon, History as HistoryIcon } from '@mui/icons-material';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import ReportDashboard from '../components/ReportDashboard';
import DateBasedChecklists from '../components/DateBasedChecklists';
import TabPanel from '../components/TabPanel';

const HistoryPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Determine current tab based on URL
  const getCurrentTab = () => {
    if (location.pathname.includes('/stats')) {
      return 0;
    } else if (location.pathname.includes('/days')) {
      return 1;
    }
    return 0;
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    if (newValue === 0) {
      navigate('/history/stats');
    } else if (newValue === 1) {
      navigate('/history/days');
    }
  };

  return (
    <Box>
      <Paper elevation={1} square sx={{ mb: 4 }}>
        <Tabs
          value={getCurrentTab()}
          onChange={handleTabChange}
          centered
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab
            icon={<BarChartIcon />}
            label="Stats"
            iconPosition="start"
            sx={{ minHeight: 64 }}
          />
          <Tab
            icon={<HistoryIcon />}
            label="Days"
            iconPosition="start"
            sx={{ minHeight: 64 }}
          />
        </Tabs>
      </Paper>

      <Container maxWidth="lg">
      <Routes>
        <Route path="/" element={<Navigate to="/history/stats" replace />} />
        <Route path="/stats" element={
          <TabPanel value={getCurrentTab()} index={0}>
            <ReportDashboard />
          </TabPanel>
        } />
        <Route path="/stats/ram" element={
          <TabPanel value={getCurrentTab()} index={0}>
            <ReportDashboard />
          </TabPanel>
        } />
        <Route path="/stats/hint" element={
          <TabPanel value={getCurrentTab()} index={0}>
            <ReportDashboard />
          </TabPanel>
        } />
        <Route path="/stats/pack" element={
          <TabPanel value={getCurrentTab()} index={0}>
            <ReportDashboard />
          </TabPanel>
        } />
        <Route path="/stats/:habitId/:childHabitId" element={
          <TabPanel value={getCurrentTab()} index={0}>
            <ReportDashboard />
          </TabPanel>
        } />
        <Route path="/stats/:habitId" element={
          <TabPanel value={getCurrentTab()} index={0}>
            <ReportDashboard />
          </TabPanel>
        } />
        <Route path="/stats/:habitId/ram" element={
          <TabPanel value={getCurrentTab()} index={0}>
            <ReportDashboard />
          </TabPanel>
        } />
        <Route path="/stats/:habitId/hint" element={
          <TabPanel value={getCurrentTab()} index={0}>
            <ReportDashboard />
          </TabPanel>
        } />
        <Route path="/stats/:habitId/pack" element={
          <TabPanel value={getCurrentTab()} index={0}>
            <ReportDashboard />
          </TabPanel>
        } />
        <Route path="/days" element={
          <TabPanel value={getCurrentTab()} index={1}>
            <Card>
              <CardContent>
                <DateBasedChecklists filterMode="past" />
              </CardContent>
            </Card>
          </TabPanel>
        } />
        <Route path="/days/ram" element={
          <TabPanel value={getCurrentTab()} index={1}>
            <Card>
              <CardContent>
                <DateBasedChecklists filterMode="past" />
              </CardContent>
            </Card>
          </TabPanel>
        } />
        <Route path="/days/hint" element={
          <TabPanel value={getCurrentTab()} index={1}>
            <Card>
              <CardContent>
                <DateBasedChecklists filterMode="past" />
              </CardContent>
            </Card>
          </TabPanel>
        } />
        <Route path="/days/pack" element={
          <TabPanel value={getCurrentTab()} index={1}>
            <Card>
              <CardContent>
                <DateBasedChecklists filterMode="past" />
              </CardContent>
            </Card>
          </TabPanel>
        } />
      </Routes>
      </Container>
    </Box>
  );
};

export default HistoryPage;